require('./stackedMap');

var MODULE_NAME = 'ui.bootstrap.module.stackedMap';

angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);

module.exports = MODULE_NAME;



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/stackedMap/index.js
// module id = 384
// module chunks = 0